import { Divider } from "@mui/material";
import { motion, useInView } from "framer-motion";
import React, { useRef } from "react";

export default function AboutUs() {
  const data = [
    {
      title: "No.1",
      subtitle: ["Commercial staffing", "outsourcing solution"],
    },
    {
      title: "60+",
      subtitle: ["Clients Nationwide", "International & Local enterprises"],
    },
    {
      title: "14.000+",
      subtitle: ["Employees Nationwide", "commercial & Manufacturing"],
    },
    { title: "170.000+", subtitle: ["Candidates", "In Database"] },
  ];
  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 1 },
  };
  const translateUp = {
    initial: { y: 100, opacity: 0 }, // Starts below the view
    animate: { y: 0, opacity: 1 }, // Moves to its position and fades in
    transition: { duration: 1.5, ease: "easeInOut" },
  };

  // Define stagger animation for items
  const staggerContainer = {
    animate: {
      transition: {
        staggerChildren: 0.3, // Delay between each child animation
      },
    },
  };
  const ref = useRef(null);

  // Detect when the container is in view
  const footerRef = useRef(null);

  // Detect when the container is in view
  const isInView = useInView(ref, { margin: "0% 0% 0% 0%" });
  const footerInView = useInView(footerRef, { margin: "0px 0px -100px 0px" });
  return (
    <>
      <motion.div
        ref={ref}
        style={{ backgroundImage: "url('/icons/navigation/bg.png')" }}
        className="h-[620px] w-[1440px] p-[135px] flex items-center justify-between  gap-24"
      >
        <motion.div
          className="items-center w-[605px]"
          variants={fadeInUp}
          initial="initial"
          animate={isInView ? "animate" : "initial"} // Animate only if in view
        >
          <h1 className="font-bold text-[40px] inset-1  text-white">
            UNLEASH YOUR RESOURCES
          </h1>
          <br />
          <p className="font-normal text-lg text-justify text-white mr-[21px] ">
            In a rapidly evolving business environment, Spiral LLC stands at the
            forefront by harnessing the power of resources to drive innovation
            and excellence. Our innovative outsourcing solutions and strategic
            partnerships empower our clients to achieve sustained success and
            create enduring value.
            <br /> <br />
            With a commitment to transforming challenges into opportunities,
            Spiral is dedicated to helping businesses excel and grow, no matter
            where or when they need us.
          </p>
        </motion.div>
        <motion.img
          className="items-center"
          src="/icons/navigation/RUNNER.png"
          alt="Runner"
          variants={fadeInUp}
        />
      </motion.div>
      <motion.footer
        ref={footerRef}
        style={{ backgroundImage: "url('/icons/navigation/FRAME.png')" }}
        className="flex h-[210px] w-[1440px] text-center items-center justify-between px-24"
        variants={staggerContainer}
        initial="initial"
        animate={footerInView ? "animate" : "initial"} // Animate only if in view
      >
        {data.map((item, index) => (
          <React.Fragment key={index}>
            <motion.div className="py-14" variants={translateUp}>
              <h1 className="text-center text-white font-bold text-[40px]">
                {item.title}
              </h1>
              {item.subtitle.map((sub, subIndex) => (
                <h2 key={subIndex} className="text-[20px] text-white font-normal">
                  {sub}
                </h2>
              ))}
            </motion.div>
            {index < 3 && (
              <Divider
                style={{
                  backgroundColor: "white",
                  width: "3px",
                  height: "94px",
                }}
                orientation="vertical"
                variant="middle"
              />
            )}
          </React.Fragment>
        ))}
      </motion.footer>
    </>
  );
}
